import React, { useState } from 'react';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { Button, Tooltip } from '@zep/ui';
import { useExplore, useExploreEdu } from '../../../services';
import S from './Explore.module.scss';
import ExploreGrid from './ExploreGrid';
import { LandingAgency } from './LandingAgency';
export const Explore = (props: ExploreProps) => {
  const {
    t
  } = useTranslation(['common', 'home']);
  const isEdu = !!props.isEdu;
  const explore = useExplore({
    enabled: !isEdu
  });
  const exploreEdu = useExploreEdu({
    enabled: isEdu
  });
  const exploreItems = isEdu ? exploreEdu : explore;
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const allCategories = [t('common:space.category.all'), ...(exploreItems.data?.category ?? [])];
  return <>
      <ExploreBanner title={t('home:explore.banner.message')} data-sentry-element="ExploreBanner" data-sentry-source-file="Explore.tsx" />
      <div className={S.page_wrapper}>
        <div className={S.page_container}>
          <div className={S.reference_title}>
            <span>{t('home:tutorial_title')}</span>
            <Tooltip placement={'top-end'} flip={false} title={t('home:explore.zepPartners.tooltip')} data-sentry-element="Tooltip" data-sentry-source-file="Explore.tsx">
              <span className={S.zep_partners}>
                {t('home:explore.zepPartners.title')}
                <img className={S.premium_partners_icon} src="/images/partners/premium-partners-icon.png" alt="premium-partners" />
              </span>
            </Tooltip>
          </div>
          <ExploreCategorySelector allCategories={allCategories} selectedIndex={selectedCategoryIndex} onCategoryChange={setSelectedCategoryIndex} data-sentry-element="ExploreCategorySelector" data-sentry-source-file="Explore.tsx" />
          <ExploreGrid items={exploreItems.data?.items ?? []}
        // @ts-ignore
        partners={exploreItems.data?.partners} selectedCategory={selectedCategoryIndex > 0 ? allCategories[selectedCategoryIndex] : ''} data-sentry-element="ExploreGrid" data-sentry-source-file="Explore.tsx" />
        </div>
        <LandingAgency title={t('home:explore.footer.title')} description={t('home:explore.footer.description')} buttonText={t('home:explore.footer.buttonTitle')} buttonLink={t('home:explore.footer.buttonLink')} mobileImageSrc={t('home:explore.footer.mobileImageSrc')} tabletImageSrc={t('home:explore.footer.tabletImageSrc')} desktopImageSrc={t('home:explore.footer.desktopImageSrc')} imageAlt={'explore_intro_image'} isUseMotion={false} data-sentry-element="LandingAgency" data-sentry-source-file="Explore.tsx" />
      </div>
    </>;
};
const ExploreBanner = (props: {
  title: string;
}) => <div className={S.page_banner_wrapper} data-sentry-component="ExploreBanner" data-sentry-source-file="Explore.tsx">
    <div className={cns(S.page_container, S.banner_container)}>
      <div className={S.banner_message}>{props.title}</div>
      <img className={S.banner_image} src={'/images/banners/reference_banner_background.png'} />
    </div>
  </div>;
const ExploreCategorySelector = (props: ExploreCategorySelectorProps) => {
  const {
    allCategories,
    selectedIndex,
    onCategoryChange
  } = props;
  const selectCategory = (index: number) => {
    if (selectedIndex !== index) {
      logger.track('home_explore_category_click', {
        category: [allCategories[index]]
      });
    }
    onCategoryChange(index);
  };
  return <div className={S.category_wrapper} data-sentry-component="ExploreCategorySelector" data-sentry-source-file="Explore.tsx">
      <div className={S.category}>
        {allCategories.map((category, index) => <Button key={index} variant={selectedIndex === index ? 'primary' : 'white'} className={S.category_item} rounded bordered onClick={() => selectCategory(index)}>
            {category}
          </Button>)}
      </div>
    </div>;
};
type ExploreProps = {
  isEdu?: boolean;
};
type ExploreCategorySelectorProps = {
  allCategories: string[];
  selectedIndex: number;
  onCategoryChange: (index: number) => void;
};